import { api } from '@/lib/api';
import type { ActivityResponse, ActivityFeedResponse, ActivityFeedQuery, CreateActivityRequest, UpdateActivityRequest } from '@troia-v3/types';

/**
 * Activities Service
 *
 * Serviço para gerenciar atividades de leads
 */
export const activitiesService = {
  /**
   * Buscar atividades de um lead
   */
  async getLeadActivities(leadId: string, query?: Partial<ActivityFeedQuery>): Promise<ActivityFeedResponse> {
    const response = await api.get(`/leads/${leadId}/activities`, {
      params: query
    });
    return response.data.data;
  },

  /**
   * Registrar atividade de lead
   */
  async addLeadActivity(leadId: string, data: Omit<CreateActivityRequest, 'entityType' | 'entityId' | 'category' | 'actorType' | 'actorId'>): Promise<ActivityResponse> {
    const response = await api.post(`/leads/${leadId}/activities`, data);
    return response.data.data;
  },

  /**
   * Atualizar atividade
   */
  async updateActivity(activityId: string, data: UpdateActivityRequest): Promise<ActivityResponse> {
    const response = await api.put(`/activities/${activityId}`, data);
    return response.data.data;
  },

  /**
   * Excluir atividade
   */
  async deleteActivity(activityId: string): Promise<void> {
    await api.delete(`/activities/${activityId}`);
  }
};
